module.exports = __webpack_public_path__ + "static/media/art16.d14d5d29.jpg";